var Locale = {
  AE: 'ae',
  AR: 'ar',
  AU: 'au',
  BG: 'bg',
  BR: 'br',
  CA: 'ca',
  CH: 'ch',
  CZ: 'cz',
  DE: 'de',
  DK: 'dk',
  ES: 'es',
  ES_US: 'es-us',
  FI: 'fi',
  FR: 'fr',
  GB: 'gb',
  GR: 'gr',
  HK: 'hk',
  HR: 'hr',
  HU: 'hu',
  ID: 'id',
  IE: 'ie',
  IN: 'in',
  IT: 'it',
  JP: 'jp',
  KR: 'kr',
  MX: 'mx',
  MY: 'my',
  NL: 'nl',
  NO: 'no',
  NZ: 'nz',
  PL: 'pl',
  PT: 'pt',
  RO: 'ro',
  RU: 'ru',
  SE: 'se',
  SG: 'sg',
  SK: 'sk',
  TH: 'th',
  TR: 'tr',
  UA: 'ua',
  US: 'us',
  VN: 'vn',
  ZH_CN: 'zh-cn',
  ZH_HK: 'zh-hk'
};
var SupportedHomeLocales = {
  AE: 'ae',
  AU: 'au',
  BG: 'bg',
  BR: 'br',
  CA: 'ca',
  CH: 'ch',
  DE: 'de',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  GR: 'gr',
  HK: 'hk',
  HU: 'hu',
  ID: 'id',
  IE: 'ie',
  IN: 'in',
  IT: 'it',
  JP: 'jp',
  MY: 'my',
  NL: 'nl',
  NZ: 'nz',
  PL: 'pl',
  PT: 'pt',
  RO: 'ro',
  RU: 'ru',
  SG: 'sg',
  TR: 'tr',
  UA: 'ua',
  US: 'us'
};
var SupportedBusinessLocales = {
  '': 'gb',
  AE: 'ae',
  AU: 'au',
  BG: 'bg',
  BR: 'br',
  CA: 'ca',
  CH: 'ch',
  CZ: 'cz',
  DE: 'de',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  GB: 'gb',
  GR: 'gr',
  HK: 'hk',
  HU: 'hu',
  ID: 'id',
  IE: 'ie',
  IN: 'in',
  IT: 'it',
  JP: 'jp',
  MY: 'my',
  NL: 'nl',
  NO: 'no',
  NZ: 'nz',
  PL: 'pl',
  PT: 'pt',
  RO: 'ro',
  RU: 'ru',
  SE: 'se',
  SG: 'sg',
  TR: 'tr',
  UA: 'ua',
  US: 'us',
  ZH_HK: 'zh-hk'
};
var EEALocales = [Locale.BG, Locale.DE, Locale.ES, Locale.GR, Locale.FR, Locale.IT, Locale.HU, Locale.IE, Locale.NL, Locale.NO, Locale.PL, Locale.PT, Locale.RO];
var EuropeLocales = [].concat(EEALocales, [Locale.GB, Locale.CH, Locale.UA]);
var EuropeWithoutGBIELocales = EuropeLocales.filter(function (country) {
  return country !== Locale.GB && country !== Locale.IE;
});
var AsiaLocales = [Locale.AE, Locale.HK, Locale.IN, Locale.JP, Locale.MY, Locale.RU, Locale.SG, Locale.TR];
var PacificLocales = [Locale.AU, Locale.NZ];
var SouthAmLocales = [Locale.BR];
var NorthAmLocales = [Locale.CA, Locale.US];
var LocaleValues = Object.keys(Locale).map(function (key) {
  return Locale[key];
});
export default Locale;
export { LocaleValues, EEALocales, SupportedHomeLocales, SupportedBusinessLocales, EuropeWithoutGBIELocales, AsiaLocales, PacificLocales, SouthAmLocales, NorthAmLocales };